import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  ActionsContainer,
  TitleText,
  AllSetContainer,
  FinishedSubtitle,
  Link
} from '../Components/Comprehension/Comprehension.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { utils } from 'kb-shared';
import { getReturnBackRoute } from 'screens/InformedConsent/ConsentStateManager.utils';

export const Error = () => {
  const { pathname, text } = getReturnBackRoute();

  return (
    <AllSetContainer>
      <TitleText>Something went wrong</TitleText>
      <FinishedSubtitle>
        An error happened while we were trying to show your consent. If the problem persist, contact
        your care team at{' '}
        <Link href={`mailto:${utils.KBContacts.navigatorEmail}?subject=Consent Forms`}>
          {utils.KBContacts.navigatorEmail}
        </Link>{' '}
        or <Link href="tel://1-855-KND-BODY">1-855-KND-BODY</Link>.
      </FinishedSubtitle>
      <ActionsContainer>
        <Button
          label="Reload"
          category="primary"
          size="lg"
          onClick={() => window.location.reload()}
        />
        <RouterLink to={pathname}>
          <Button label={text} category="secondary" size="lg" />
        </RouterLink>
      </ActionsContainer>
    </AllSetContainer>
  );
};
